<template>
  <LayoutModalComponent
    :parentRoute="parentRoute"
  >
    <LayoutCollectionTypeHeadingComponent
      :pageData="pageData"
      :parentPageData="parentPageData"
      :routeName="routeName"
      :injectClose="false"
    >
      <span v-html="title" />
    </LayoutCollectionTypeHeadingComponent>

    <CoreBlocksComponent
      v-if="blocks?.length"
      :blocks="blocks"
    />
  </LayoutModalComponent>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  routeName: [String, Object],
  parentPageData: Object,
  parentRoute: Object,
  parentRouteName: String
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData))
})

const blocks = computed(() => {
  return localizedData?.value?.blocks
})

const title = computed(() => {
  const title = localizedData.value.titles?.current_locale || localizedData.value.titles?.i18n_string_en
  const author = localizedData.value.authors?.current_locale || localizedData.value.authors?.i18n_string_en
  if (title && author) {
    return `<em>${title}</em><br />${author}`
  } else {
    return `<em>${title}</em>`
  }
})
</script>

<style module>
.root {
}
</style>
